import { PureFunctional, React } from '../react';
import cx from '../react-toolbox-extended/componentstyling/tabs.less';

export default PureFunctional<{ 
    activeIndex: number, 
    inverse?: boolean, 
    fill?: boolean, 
    onChange: any, 
    smallScreen?: boolean,
    containerClass?: string,
    /* tslint:disable */
    children?: Array<React.ReactElement<any>>,
    /* tslint:enable */
    }>(`TabsSelector`)(
    ({ activeIndex, inverse, fill, onChange, children, smallScreen, containerClass }) => (
        <div className={cx('selector', { inverse, fill })}>
            <div role="tablist" 
                className={cx('selector-list', containerClass,
                    smallScreen? 'selector-list-smallScreen':'', 
                    'selector-highlight',
                    { inverse, fill })}>
                {children.qSelect((el: any, idx: number) => {
                        return (
                            <button
                            tabIndex={0}
                            key={idx}
                            role={el.props.role}
                            aria-selected={idx === activeIndex}
                            aria-controls={`panel-${idx}`}
                            className={
                                cx('button', 'label',
                                idx === activeIndex ? 'active' : '',
                                fill ? 'fill': '',
                                inverse ? 'inverse': '',
                                smallScreen ? 'tab-smallscreen': '')}
                            title={el.props.title }                                 
                            onClick={() => onChange(idx)}>{el.props.title}</button>
                        );
                })}
            </div>
        </div>
));



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/react-toolbox-extended/tabs.tsx